
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage",
      function () {
        return require("private-next-pages/homepage/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homepage"])
      });
    }
  